import { SalesChannelType } from '@fd/customHooks/useQueryRMSSalesChannels';

export const POS_CHANNELS = new Set<SalesChannelType>([SalesChannelType.POS, SalesChannelType.Pos]);

export const ONLINE_CHANNELS = new Set<SalesChannelType>([
  SalesChannelType.FLIPDISH_WEB_APP,
  SalesChannelType.FLIPDISH_MOBILE_APP,
  SalesChannelType.FLIPDISH_KIOSK,
  SalesChannelType.FLIPDISH_PHONE_AGENT,
  SalesChannelType.UBER_EATS,
  SalesChannelType.DELIVEROO,
  SalesChannelType.JUST_EATS,
  SalesChannelType.WEB_APP,
  SalesChannelType.MOBILE_APP,
  SalesChannelType.KIOSK,
  SalesChannelType.Web,
  SalesChannelType.PhoneAgent,
  SalesChannelType.App,
  SalesChannelType.EXTERNAL_APP,
]);

export function isOnlineChannel(type: SalesChannelType): boolean {
  return ONLINE_CHANNELS.has(type);
}

export function isPOSChannel(type: SalesChannelType): boolean {
  return POS_CHANNELS.has(type);
}
